module.exports = __webpack_public_path__ + "images/pattern-1@2x.ff3adab279632a0b2b3cd3a86ece16b6.jpg";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/images/pattern-1@2x.jpg
// module id = 1023
// module chunks = 0